module.exports = __webpack_public_path__ + "static/HKGroteskPro-SemiBold-b02a580cb86453ac7ccff8498029fe1e.woff2";